import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { KycVerificationStatus } from 'store/models';

interface KycVerificationState {
  statuses: Record<number, KycVerificationStatus>;
  lastVerifiedCardId: number | null;
}

const initialState: KycVerificationState = {
  statuses: {},
  lastVerifiedCardId: null,
};

export const kycVerificationSlice = createSlice({
  name: 'kycVerification',
  initialState,
  reducers: {
    setCardVerificationStatus: (state, action: PayloadAction<{ cardId: number; status: KycVerificationStatus }>) => {
      state.statuses[action.payload.cardId] = action.payload.status;
      state.lastVerifiedCardId = action.payload.cardId;
    },
    clearCardVerificationStatuses: () => initialState,
  },
});

export const cardVerificationStatusSelector =
  (cardId: number | undefined | null) =>
  (state: { kycVerification: KycVerificationState }): KycVerificationStatus | undefined =>
    cardId ? state.kycVerification.statuses[cardId] : undefined;

export const lastVerifiedCardIdSelector = (state: { kycVerification: KycVerificationState }): number | null =>
  state.kycVerification.lastVerifiedCardId;

export const { setCardVerificationStatus, clearCardVerificationStatuses } = kycVerificationSlice.actions;

export default kycVerificationSlice.reducer;
